// Route a finished push-to-talk transcript: fire the ask, or stage it for
// tap-to-confirm. Staging costs one tap when the transcript WAS meant;
// auto-firing a wrong one costs a metered ask and the user's trust.
// Shared by the /ask floor surface and the ⌘K palette mic.
//
// Staged when:
//  - fragment: a ≤2-word transcript is more often a cut-off hold than a whole
//    question (telemetry 2026-07-30: "many bins" auto-fired as its own ask;
//    the user immediately re-held and asked in full). One-word follow-ups
//    ("Makuvele") pay one confirm tap — the stage announces itself aloud.
//  - very-low confidence (< 0.35 where the engine measured at all): probably
//    misheard. Unknown confidence (0/undefined — usePushToTalk normalises 0
//    to undefined) submits as usual: short follow-ups ("and this season")
//    score low often, which is why the threshold is very-low only.
//
// Transcripts under 3 chars are NOT staged — they fall through to the
// surface's own too-short handling (hint on the floor, ≥3-char gate in ⌘K).
export function shouldStageTranscript(transcript: string, confidence: number | undefined): boolean {
  const t = transcript.trim()
  if (t.length < 3) return false
  if (t.split(/\s+/).length <= 2) return true
  return confidence !== undefined && confidence < 0.35
}
